import { render } from "./MoveAccount.vue?vue&type=template&id=25362a03"
import script from "./MoveAccount.vue?vue&type=script&lang=js"
export * from "./MoveAccount.vue?vue&type=script&lang=js"

import "./MoveAccount.vue?vue&type=style&index=0&id=25362a03&lang=scss"

import exportComponent from "/opt/app-root/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__